<template>
  <div>
    <v-tooltip v-if="isAlert" bottom>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
          class="px-2 py-1 font-weight-bold amber--text text--darken-2 d-flex align-center"
          style="
            background-color: #fff8e1;
            border-radius: 8px;
            width: fit-content;
          "
        >
          <v-icon left size="18" class="mr-1" color="amber darken-2"
            >ph-fill ph-warning-circle</v-icon
          >
          <span class="text-truncate" style="flex: 1">{{
            formattedUsage
          }}</span>
        </span>
      </template>
      <span>{{ tooltipMessage }}</span>
    </v-tooltip>
    <span v-else>{{ formattedUsage }}</span>
  </div>
</template>

<script>
import {
  UNLIMITED,
  UNLIMITED_LABEL,
} from "@/helpers/variables/backendConstants";

export default {
  name: "LicenseUsageCell",

  props: {
    usage: {
      type: Object,
      default: null,
    },
    licenseName: {
      type: String,
      required: true,
    },
  },

  computed: {
    formattedUsage() {
      if (!this.usage) {
        return "";
      }
      const used = this.usage.used;
      const limitValue = this.usage.limit;
      const isUnlimited = limitValue === UNLIMITED;
      const limitLabel = isUnlimited ? UNLIMITED_LABEL : limitValue;
      return `${used} / ${limitLabel}`;
    },
    isAlert() {
      if (!this.usage) {
        return false;
      }
      const limitValue = this.usage.limit;
      if (limitValue == null || limitValue === UNLIMITED) {
        return false;
      }
      return this.usage.used > limitValue;
    },
    tooltipMessage() {
      return this.$t("licensing.alertTooltip");
    },
  },
};
</script>
